export default "__VITE_ASSET__jAFwNvaw__";